import React from 'react'

const ReportCardMobile = () => {
  return (
    <div>ReportCardMobile</div>
  )
}

export default ReportCardMobile